import React, { useEffect, useState } from "react";
import CustomerData from "../../Components/FormCustomer/CustomerData";
import CustomerAddress from "../../Components/FormCustomer/CustomerAddress";
import { api } from "../../config/api";
import { BackEndRoutes } from "../../config/back-end-routes";
import { useNavigate, useParams } from "react-router-dom";
import { FrontEndRoutes } from "../../config/front-end-routes";
import CustomerRequests from "../../Components/FormCustomer/CustomerRequests";
import CustomerPriceTable from "../../Components/FormCustomer/CustomerPriceTable";
import { toast } from "react-toastify";
import { Button, Spinner } from "react-bootstrap";

interface Pedidos {
  idCpnj?: string
}

const FormCustomer: React.FC<Pedidos> = ({idCpnj}) => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const { id } = useParams<{ id: string }>();
  const [activeTab, setActiveTab] = useState("dados");
  const [disableSave, setDisableSave] = useState(false)
  const [disableCnpj, setDisableCnpj] = useState(false)
  const [pedidos, setPedidos] = useState([])
  const [customerData, setCustomerData] = useState({
    pfpj: 'FÍSICA',
    cnpj: '',
    ierg: '',
    razao: '',
    nome_fantasia: '',
    telefone: '',
    celular: '',
    email: '',
    id_vendedor: 132,
    cep: '',
    endereco: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    estado: '',
    id_tabela: 0,
    status: 0
  })
  const [invalidFields, setInvalidFields] = useState({
    cnpj: false,
    ierg: false,
    nome_fantasia: false,
    razao: false,
    telefone: false,
    celular: false,
    email: false,
    cep: false,
    endereco: false,
    numero: false,
    bairro: false,
    cidade: false,
    estado: false,
  });

  const getData = () => {
    if (!idCpnj && !id) {
      console.error("Nenhum ID de cliente fornecido.");
      return;
    }

    setLoading(true);
  
    api.get(BackEndRoutes.routes.CLIENTES.FIND.replace(":cnpj", idCpnj || id))
      .then((response: any) => {
        const data = response.data;
        setCustomerData({
          pfpj: data?.pfpj || "FÍSICA",
          cnpj: data?.cnpj || "",
          ierg: data?.ierg || "",
          razao: data?.razao || "",
          nome_fantasia: data?.nome_fantasia || "",
          telefone: data?.telefone || "",
          celular: data?.celular || "",
          id_vendedor: data?.id_vendedor || 132,
          email: data?.email || "",
          cep: data?.cep || "",
          endereco: data?.endereco || "",
          numero: data?.numero || "",
          complemento: data?.complemento || "",
          bairro: data?.bairro || "",
          cidade: data?.cidade || "",
          estado: data?.estado || "",
          id_tabela: data?.tabela?.id_tabela || 0,
          status: data?.status || 0,
        });
  
        setPedidos(data?.pedidos || []);
        setDisableCnpj(true);
      })
      .catch((error) => {
        console.error("Erro ao buscar o cliente", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  
  

  const saveFunction = () => {
    const requiredFields = [
      "cnpj",
      "ierg",
      "razao",
      "nome_fantasia",
      "celular",
      "telefone",
      "email",
      "cep",
      "endereco",
      "numero",
      "bairro",
      "cidade",
      "estado",
    ];
  
    const newInvalidFields = requiredFields.reduce((acc, field) => {
      acc[field] = !customerData[field as keyof typeof customerData];
      return acc;
    }, {} as Record<string, boolean>);
  
    setInvalidFields((prevState) => ({
      ...prevState,
      ...newInvalidFields,
    }));
  
    const valid = !Object.values(newInvalidFields).some((field) => field);
  
    if (valid) {
      handleSave(customerData);
    }
  };

  const handleSave = (data: any) => {
    setLoading(true);
  
    const request = id
      ? api.put(BackEndRoutes.routes.CLIENTES.UPDATE.replace(":cnpj", id), data)
      : api.post(BackEndRoutes.routes.CLIENTES.POST, data);
  
    request
      .then((response) => {
        console.log("Sucesso:", response.data);
        navigate(FrontEndRoutes.CLIENTES.LIST);
      })
      .catch((error) => {
        console.error("Erro ao salvar cliente:", error);
        toast.error("Falha ao salvar cliente. Por favor, tente novamente.");
      })
      .finally(() => {
        setLoading(false);
      });
  };  

  const handleReturn = () => {
    navigate(FrontEndRoutes.CLIENTES.LIST)
  }

  useEffect(() => {
    if (idCpnj || id) {
      getData();
    }
  }, [idCpnj, id]);
  

  return (
    <div className="card h-100" style={{ borderColor: "#3490dc", borderRadius: "6px" }}>
      <div className="card-header">
        <ul className="nav nav-tabs card-header-tabs" id="myTab" role="tablist">
          <li className="nav-item outline-black " role="presentation">
            <button
              className={`nav-link ${activeTab === "dados" ? "active" : "text-black"}`}
              id="dados-tab"
              type="button"
              onClick={() => setActiveTab("dados")}
            >
              Dados
            </button>
          </li>

          <li className="nav-item" role="presentation">
            <button
              className={`nav-link	${pedidos.length !== 0 ? "" : "d-none "} ${activeTab === "pedidos" ? "active" : "text-black"}`}
              id="pedidos-tab"
              type="button"
              onClick={() => setActiveTab("pedidos")}
            >
              Pedidos
            </button>
          </li>
        </ul>
      </div>

      <div className="tab-content mt-3 border border-top-0 rounded-bottom" id="myTabContent">

        {/* Dados */}
        <div
          className={`tab-pane fade ${activeTab === "dados" ? "show active" : ""}`}
          id="dados"
          role="tabpanel"
          aria-labelledby="dados-tab"
        >
          <div className="card-body row d-flex justify-content-center">
            <h3 className="text-center mb-4">Dados Do Cliente</h3>
            <div className="p-2">
              <CustomerData
                customerData={customerData}
                setCustomerData={setCustomerData}
                isInvalid={invalidFields}
                setIsInvalid={setInvalidFields}
                setShowModal={setDisableSave}
                disableCnpj={disableCnpj}
                idCnpj={idCpnj}
              />
            </div>
            <div className="border-top border-2 border-secondary-subtle p-3">
              <h5 className="mb-2">Informações do Endereço</h5>
              <CustomerAddress
                idCnpj={idCpnj}
                customerData={customerData}
                setCustomerData={setCustomerData}
                isInvalid={invalidFields}
                setIsInvalid={setInvalidFields}
              />
            </div>
            <div className="border-top border-2 border-secondary-subtle p-4">
              <h5 className="mb-4">Tabela de Preços</h5>
              <CustomerPriceTable
              idCnpj={idCpnj}
                customerData={customerData}
                setCustomerData={setCustomerData}
              />
            </div>
          </div>
        </div>

        {/* Pedidos */}
        <div
          className={`tab-pane fade ${activeTab === "pedidos" ? "show active" : ""}`}
          id="pedidos"
          role="tabpanel"
          aria-labelledby="pedidos-tab"
        >
          <div className="card-body">
            <CustomerRequests
                pedidos={pedidos}
            />
          </div>
        </div>

        {idCpnj ? <></> : <>
          <div className="card-footer d-flex col gap-4 justify-content-end" style={{ borderColor: "#3490dc" }}>
            <Button
              type="button"
              className="mt-3"
              variant="secondary"
              disabled={loading}
              onClick={handleReturn}>
              {loading ? <Spinner animation="border" size="sm" /> : "Voltar"}
            </Button>
            <Button type="submit" className="mt-3" disabled={loading} onClick={saveFunction}>
              {loading ? <Spinner animation="border" size="sm" /> : "Salvar"}
            </Button>
          </div>
        </>}
      </div>
    </div>
  );
};

export default FormCustomer;
